import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useMortalityMobidityChartsDataContext } from './hooks/useMortalityMobidityChartsDataContext';

export const DeathMothersAge = () => {
    const { chartData } = useMortalityMobidityChartsDataContext();

    return (
        <Donut
            title={'Obitos Maternos - Idade da Mãe'}
            subtitles={chartData?.deathMothersAge?.map((item) => item.description)}
            chartData={chartData?.deathMothersAge || []}
            colors={defaultColors.slice(0, chartData?.deathMothersAge?.length) || []}
            height={400}
        />
    );
};
